"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRandomColor = exports.getRandomIcon = exports.getUserRuleParticipation = exports.getSubscriptionStatusColor = exports.isAllowedToUsePlatform = exports.userSubscriptionStatus = exports.expiredSubscriptionStatuses = exports.SubscriptionStatusBanner = exports.checkPasswordRequirements = exports.mergeIterationData = exports.minutesToHours = exports.formatUserName = exports.localeNormalizer = exports.mergeRecords = exports.eventBgColor = exports.formatSlotDuration = exports.getShadeForLabels = exports.getCustomDateRange = exports.getDifferenceInMinutes = exports.getDifferenceInColumns = exports.getDifferenceInHours = exports.subtractMonths = exports.addMonths = exports.subtractDays = exports.addDays = exports.getDayOfWeek = exports.divideSlotsIntoWeeks = exports.arrangeSlots = exports.adjustSlotToWeekBoundary = exports.areDatesOnTheSameDay = exports.getWeekdayInitials = exports.parseSpecialEventDates = exports.dateToString = exports.parseSectionSlotDateTimeSuperShort = exports.parseSectionSlotDateTime = exports.convert24To12 = exports.AMPMFormat = exports.getFirstDayOfWeek = exports.classNames = exports.parseIterationDates = void 0;
var types_1 = require("../types");
var constants_1 = require("./constants");
/* eslint-disable no-else-return */
var parseIterationDates = function (start_day, end_day, itr_type) {
    var start_date = new Date(start_day);
    var end_date = new Date(end_day);
    if (itr_type === "MONTH") {
        var year = start_date.getUTCFullYear();
        var month = start_date.toLocaleString("default", {
            month: "long",
            timeZone: "GMT",
        });
        return "".concat(month, " ").concat(year);
    }
    else {
        var start_day_1 = start_date.toLocaleString("default", {
            day: "numeric",
            month: "long",
            timeZone: "GMT",
        });
        var end_day_1 = end_date.toLocaleString("default", {
            day: "numeric",
            month: "long",
            year: "numeric",
            timeZone: "GMT",
        });
        return "".concat(start_day_1, " - ").concat(end_day_1);
    }
};
exports.parseIterationDates = parseIterationDates;
function classNames() {
    var classes = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        classes[_i] = arguments[_i];
    }
    return classes.filter(Boolean).join(" ");
}
exports.classNames = classNames;
var getFirstDayOfWeek = function (locale) {
    switch (locale) {
        case "en":
            // sunday is the first day of the week
            return 7;
        default:
            // monday is the first day of the week
            return 1;
    }
};
exports.getFirstDayOfWeek = getFirstDayOfWeek;
var AMPMFormat = function (locale) {
    return locale && locale === "en";
};
exports.AMPMFormat = AMPMFormat;
var convert24To12 = function (time) {
    var _a = time.split(":"), hours = _a[0], minutes = _a[1];
    var hoursNum = Number(hours);
    var ampm = hoursNum >= 12 ? "PM" : "AM";
    var hours12 = hoursNum % 12 || 12;
    return "".concat(hours12, ":").concat(minutes, " ").concat(ampm);
};
exports.convert24To12 = convert24To12;
var parseSectionSlotDateTime = function (start_date, end_date, locale, short) {
    if (short === void 0) { short = true; }
    var start = new Date(start_date);
    var end = new Date(end_date);
    var ampm = (0, exports.AMPMFormat)(locale);
    var startDateTime = start.toLocaleString(locale, {
        day: "numeric",
        month: short ? "numeric" : "short",
        weekday: short ? undefined : "short",
        hour: "2-digit",
        minute: "2-digit",
        hour12: ampm,
        timeZone: "GMT",
    });
    var endTime = end.toLocaleString(locale, {
        hour: "2-digit",
        minute: "2-digit",
        hour12: ampm,
        timeZone: "GMT",
    });
    return "".concat(startDateTime, " - ").concat(endTime);
};
exports.parseSectionSlotDateTime = parseSectionSlotDateTime;
var parseSectionSlotDateTimeSuperShort = function (start_date, end_date, locale, showDay) {
    var start = new Date(start_date);
    var end = new Date(end_date);
    // Format month and day with no leading zeros
    var month = start.getUTCMonth() + 1; // getUTCMonth() returns 0-11
    var day = start.getUTCDate();
    // Format hours (12-hour format) and minutes
    var startHour = start.getUTCHours();
    var startMinutes = start.getUTCMinutes();
    var startAmPm = startHour >= 12 ? "pm" : "am";
    startHour = startHour % 12 || 12; // Convert to 12-hour format
    var endHour = end.getUTCHours();
    var endMinutes = end.getUTCMinutes();
    var endAmPm = endHour >= 12 ? "pm" : "am";
    endHour = endHour % 12 || 12; // Convert to 12-hour format
    // Format time parts, omitting minutes when they're zero
    var startTime = startMinutes === 0
        ? "".concat(startHour).concat(startAmPm)
        : "".concat(startHour, ":").concat(startMinutes.toString().padStart(2, "0")).concat(startAmPm);
    var endTime = endMinutes === 0
        ? "".concat(endHour).concat(endAmPm)
        : "".concat(endHour, ":").concat(endMinutes.toString().padStart(2, "0")).concat(endAmPm);
    var monthOrder = locale === "en" ? "".concat(month, "/").concat(day) : "".concat(day, "/").concat(month);
    return showDay
        ? "".concat(monthOrder, " ").concat(startTime, " - ").concat(endTime)
        : "".concat(startTime, " - ").concat(endTime);
};
exports.parseSectionSlotDateTimeSuperShort = parseSectionSlotDateTimeSuperShort;
var dateToString = function (dateInput, format, locale) {
    var date = new Date(dateInput);
    var ampm = (0, exports.AMPMFormat)(locale);
    switch (format) {
        case "only-day":
            return date.toLocaleString(undefined, {
                day: "2-digit",
                timeZone: "UTC",
            });
        case "weekday":
            return date.toLocaleString(locale, {
                weekday: "short",
                day: "2-digit",
                timeZone: "UTC",
            });
        case "mmyy":
            return date.toLocaleString(locale, {
                month: "long",
                year: "numeric",
                timeZone: "UTC",
            });
        case "weekday-hour":
            return date.toLocaleString(locale, {
                weekday: "short",
                day: "2-digit",
                hour: "2-digit",
                month: "short",
                hour12: ampm,
                minute: "2-digit",
                timeZone: "UTC",
            });
        case "hh:mm":
            return date.toLocaleString(locale, {
                hour: "2-digit",
                minute: "2-digit",
                timeZone: "UTC",
            });
        case "dd/mm/yyyy":
            return date.toLocaleDateString(locale, {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
                timeZone: "UTC",
            });
        case "iso":
            var year = date.getUTCFullYear();
            var month = String(date.getUTCMonth() + 1).padStart(2, "0");
            var day = String(date.getUTCDate()).padStart(2, "0");
            return "".concat(year, "-").concat(month, "-").concat(day);
        // DO NOT ADD UTC
        case "month-year-local":
            return date.toLocaleDateString(locale, {
                month: "long",
                year: "numeric",
            });
        case "long":
            return date.toLocaleDateString(locale, {
                day: "numeric",
                month: "long",
                weekday: "long",
                timeZone: "UTC",
            });
        case "long-local":
            return date.toLocaleDateString(locale, {
                day: "numeric",
                month: "long",
                weekday: "long",
            });
        case "longWithYear":
            return date.toLocaleDateString(locale, {
                day: "numeric",
                month: "long",
                weekday: "long",
                year: "numeric",
                timeZone: "UTC",
            });
    }
};
exports.dateToString = dateToString;
var parseSpecialEventDates = function (eventStart, eventEnd, locale) {
    var startDate = new Date(eventStart);
    var endDate = new Date(eventEnd);
    var now = new Date();
    var isThisYear = startDate.getFullYear() === now.getFullYear() &&
        endDate.getFullYear() === now.getFullYear();
    var isSameDay = startDate.toDateString() === endDate.toDateString();
    // Format options for different cases
    var dayFormat = new Intl.DateTimeFormat(locale, {
        day: "numeric",
        timeZone: "UTC",
    });
    var monthFormat = new Intl.DateTimeFormat(locale, {
        month: "short",
        timeZone: "UTC",
    });
    var yearFormat = new Intl.DateTimeFormat(locale, {
        year: "numeric",
        timeZone: "UTC",
    });
    var weekdayFormat = new Intl.DateTimeFormat(locale, {
        weekday: "short",
        timeZone: "UTC",
    });
    if (isSameDay) {
        // For same day events
        if (isThisYear) {
            return "".concat(weekdayFormat.format(startDate), ", ").concat(dayFormat.format(startDate), " ").concat(monthFormat.format(startDate));
        }
        return "".concat(weekdayFormat.format(startDate), ", ").concat(dayFormat.format(startDate), " ").concat(monthFormat.format(startDate), " ").concat(yearFormat.format(startDate));
    }
    // For different days
    if (startDate.getMonth() === endDate.getMonth()) {
        // Same month
        if (isThisYear) {
            return "".concat(dayFormat.format(startDate), "-").concat(dayFormat.format(endDate), " ").concat(monthFormat.format(startDate));
        }
        return "".concat(dayFormat.format(startDate), "-").concat(dayFormat.format(endDate), " ").concat(monthFormat.format(startDate), " ").concat(yearFormat.format(startDate));
    }
    // Different months
    if (isThisYear) {
        return "".concat(dayFormat.format(startDate), " ").concat(monthFormat.format(startDate), " - ").concat(dayFormat.format(endDate), " ").concat(monthFormat.format(endDate));
    }
    // Different months, different years
    return "".concat(dayFormat.format(startDate), " ").concat(monthFormat.format(startDate), " ").concat(yearFormat.format(startDate), " - ").concat(dayFormat.format(endDate), " ").concat(monthFormat.format(endDate), " ").concat(yearFormat.format(endDate));
};
exports.parseSpecialEventDates = parseSpecialEventDates;
var getWeekdayInitials = function (t, locale) {
    var days = [
        t("calendars.mo"),
        t("calendars.tu"),
        t("calendars.we"),
        t("calendars.th"),
        t("calendars.fr"),
        t("calendars.sa"),
        t("calendars.su"),
    ];
    var firstDay = (0, exports.getFirstDayOfWeek)(locale);
    if (firstDay === 1) {
        return days;
    }
    else {
        return days.slice(-1).concat(days).slice(0, -1);
    }
};
exports.getWeekdayInitials = getWeekdayInitials;
var areDatesOnTheSameDay = function (date1Str, date2Str) {
    var date1 = new Date(date1Str);
    var date2 = new Date(date2Str);
    return (date1.getUTCFullYear() === date2.getUTCFullYear() &&
        date1.getUTCMonth() === date2.getUTCMonth() &&
        date1.getUTCDate() === date2.getUTCDate());
};
exports.areDatesOnTheSameDay = areDatesOnTheSameDay;
/**
 * Adjusts a slot's end time to respect week/day boundaries based on locale.
 * Returns either the original end date or 23:59:59 of the start date if it crosses a week boundary.
 */
function adjustSlotToWeekBoundary(start, end, firstDayOfWeek) {
    var startDay = start.getDay(); // 0-6, where 0 is Sunday
    var nextDay = new Date(start);
    nextDay.setDate(start.getDate() + 1);
    nextDay.setHours(0, 0, 0, 0);
    // // For English calendar (Sunday first)
    // if (firstDayOfWeek === 7 && startDay === 6 && end >= nextDay) {
    //   // Saturday crossing to Sunday
    //   const adjustedEnd = new Date(start);
    //   adjustedEnd.setHours(23, 59, 59, 999);
    //   return adjustedEnd;
    // }
    // // For other calendars (Monday first)
    // else if (firstDayOfWeek === 1 && startDay === 0 && end >= nextDay) {
    //   // Sunday crossing to Monday
    //   const adjustedEnd = new Date(start);
    //   adjustedEnd.setHours(23, 59, 59, 999);
    //   return adjustedEnd;
    // }
    // return end;
    var adjustedEnd = new Date(start);
    adjustedEnd.setHours(23, 59, 59, 999);
    return adjustedEnd;
}
exports.adjustSlotToWeekBoundary = adjustSlotToWeekBoundary;
/**
 * A generic function to arrange slots (either SectionSlot or VirtualSlot)
 * into rows of non-overlapping times.
 */
function arrangeSlots(slots) {
    // Convert start/end to Date objects for sorting/comparison
    var slotArray = slots.map(function (slot) { return (__assign(__assign({}, slot), { start: new Date(slot.start), end: new Date(slot.end) })); });
    // Sort slots: earliest start first; if tie, longer duration first
    slotArray.sort(function (a, b) {
        var startDiff = a.start.getTime() - b.start.getTime();
        if (startDiff === 0) {
            // For tie, prefer the slot that ends later (longer slot first)
            return b.end.getTime() - a.end.getTime();
        }
        return startDiff;
    });
    var rows = [];
    for (var _i = 0, slotArray_1 = slotArray; _i < slotArray_1.length; _i++) {
        var slot = slotArray_1[_i];
        var placed = false;
        // Try to place in an existing row
        for (var _a = 0, rows_1 = rows; _a < rows_1.length; _a++) {
            var row = rows_1[_a];
            // We can place if last slot in row ends before or exactly at this slot's start
            if (row[row.length - 1].end.getTime() <= slot.start.getTime()) {
                row.push(__assign(__assign({}, slot), { spanning: false }));
                placed = true;
                break;
            }
        }
        // If not placed, create a new row
        if (!placed) {
            rows.push([__assign(__assign({}, slot), { spanning: false })]);
        }
    }
    return rows;
}
exports.arrangeSlots = arrangeSlots;
/**
 * A generic function to divide slots (either SectionSlot or VirtualSlot)
 * into their corresponding weeks. If a slot spans multiple weeks,
 * it will be split, marking the first part as "start" spanning.
 * (The "end" part can be implemented similarly if desired.)
 */
function divideSlotsIntoWeeks(weeks, slots) {
    var slotsByWeek = weeks.map(function () { return []; });
    Object.keys(slots).forEach(function (slotKey) {
        var slot = slots[Number(slotKey)];
        var startTime = new Date(slot.start);
        var endTime = new Date(slot.end);
        for (var weekIndex = 0; weekIndex < weeks.length; weekIndex++) {
            var week = weeks[weekIndex];
            var weekStart = new Date(week[0]);
            var weekEnd = weekIndex < weeks.length - 1
                ? new Date(weeks[weekIndex + 1][0])
                : addDays(new Date(week[6]), 1);
            if (weekStart <= startTime && startTime < weekEnd) {
                if (endTime <= weekEnd) {
                    // The slot fits entirely within the current week
                    slotsByWeek[weekIndex].push(__assign(__assign({}, slot), { spanning: false }));
                }
                else {
                    // The slot starts in this week but continues beyond it
                    slotsByWeek[weekIndex].push(__assign(__assign({}, slot), { spanning: "start" }));
                    // If you want to handle the "end" part in the next week,
                    // you can add code here to push the remainder of the slot
                    // into the next week with spanning: "end".
                }
                break;
            }
        }
    });
    return slotsByWeek;
}
exports.divideSlotsIntoWeeks = divideSlotsIntoWeeks;
// Helper function to get the day of the week (0 for Sunday, 6 for Saturday)
function getDayOfWeek(date) {
    return date.getUTCDay();
}
exports.getDayOfWeek = getDayOfWeek;
// Helper function to add days to a date
function addDays(date, days) {
    var result = new Date(date);
    result.setUTCDate(result.getUTCDate() + days);
    return result;
}
exports.addDays = addDays;
// Helper function to subtract days from a date
function subtractDays(date, days) {
    return addDays(date, -days);
}
exports.subtractDays = subtractDays;
// Helper function to add months to a date
function addMonths(date, months) {
    var result = new Date(date);
    result.setMonth(result.getMonth() + months);
    return result;
}
exports.addMonths = addMonths;
// Helper function to subtract months from a date
function subtractMonths(date, months) {
    return addMonths(date, -months);
}
exports.subtractMonths = subtractMonths;
function getDifferenceInHours(startDate, endDate) {
    var start = new Date(startDate);
    var end = new Date(endDate);
    // Calculate the difference in milliseconds
    var differenceInMilliseconds = end.getTime() - start.getTime();
    // Convert milliseconds to hours
    var differenceInHours = Math.round(differenceInMilliseconds / (1000 * 60 * 60));
    return differenceInHours;
}
exports.getDifferenceInHours = getDifferenceInHours;
function getDifferenceInColumns(startDate, endDate) {
    var start = new Date(startDate);
    var end = new Date(endDate);
    // Difference in milliseconds
    var differenceInMilliseconds = end.getTime() - start.getTime();
    // Convert milliseconds to minutes
    var differenceInMinutes = differenceInMilliseconds / (1000 * 60);
    // Each hour has 60 minutes
    // If granularity = 12, that means 12 columns per hour = 5 minutes per column
    // => differenceInColumns = (differenceInMinutes / (60 / granularity))
    // which is equivalent to differenceInMinutes * (granularity / 60)
    var differenceInColumns = Math.round(differenceInMinutes * (constants_1.GRID_GRANULARITY / 60));
    return differenceInColumns;
}
exports.getDifferenceInColumns = getDifferenceInColumns;
function getDifferenceInMinutes(startDate, endDate) {
    // Calculate the difference in milliseconds
    var start = new Date(startDate);
    var end = new Date(endDate);
    var differenceInMilliseconds = end.getTime() - start.getTime();
    // Convert milliseconds to minutes
    var differenceInMinutes = differenceInMilliseconds / (1000 * 60);
    return differenceInMinutes;
}
exports.getDifferenceInMinutes = getDifferenceInMinutes;
function getCustomDateRange(startDate, endDate, locale, type) {
    if (type === void 0) { type = "virgueria"; }
    var start = new Date(startDate);
    var end = new Date(endDate);
    var daysMatrix = [];
    // this will return the days in a 2d matrix by week and adjusted to start on Monday/Sunday
    if (type === "virgueria") {
        // Calculate the difference to adjust the start to the previous Monday and end to the next Sunday
        var startDayOfWeek = getDayOfWeek(start);
        var endDayOfWeek = getDayOfWeek(end);
        var firstDayOfWeek = (0, exports.getFirstDayOfWeek)(locale);
        // Adjust the start date to the beginning of the week
        var startAdjustment = firstDayOfWeek === 7
            ? startDayOfWeek // Sunday is the first day
            : startDayOfWeek === 0
                ? 6 // Adjust Sunday (0) to the previous Monday (first day is Monday)
                : startDayOfWeek - 1;
        // Adjust the end date to the end of the week
        var endAdjustment = firstDayOfWeek === 7
            ? (6 - endDayOfWeek + 7) % 7 // Calculate days to the next Saturday
            : (7 - endDayOfWeek) % 7; // Calculate days to the next Sunday
        var adjustedStart = subtractDays(start, startAdjustment);
        var adjustedEnd = addDays(end, endAdjustment);
        var currentWeek = [];
        var currentDay = adjustedStart;
        while (currentDay <= adjustedEnd) {
            currentWeek.push(new Date(currentDay));
            if (currentWeek.length === 7) {
                daysMatrix.push(currentWeek);
                currentWeek = [];
            }
            currentDay = addDays(currentDay, 1);
        }
        // Add the last week if it wasn't completed
        if (currentWeek.length > 0) {
            daysMatrix.push(currentWeek);
        }
    }
    else {
        var currentDay = start;
        while (currentDay <= end) {
            daysMatrix.push(currentDay);
            currentDay = addDays(currentDay, 1);
        }
    }
    return daysMatrix;
}
exports.getCustomDateRange = getCustomDateRange;
/**
 * Generates a deterministic ColorIndex for any combination of numbers.
 * The same set of numbers (regardless of order) will always produce the same shade.
 *
 * @param numbers - Array of numbers to generate a shade for
 * @param availableShades - Array of possible ColorIndex values to choose from (defaults to [100, 200, 300, 400, 500, 600, 700, 800, 900])
 * @returns A ColorIndex value deterministically derived from the input numbers
 */
function getShadeForLabels(labels) {
    // Sort numbers to ensure the same set in any order produces the same result
    var sortedLabels = __spreadArray([], labels, true).sort(function (a, b) { return a - b; });
    var availableShades = [100, 200, 300, 400, 500, 600, 700];
    // Create a hash by combining all numbers
    // Using prime numbers to reduce collisions
    var hash = 0;
    for (var i = 0; i < sortedLabels.length; i++) {
        // Use different prime multipliers for each position
        var prime = [31, 37, 41, 43, 47, 53, 59, 61, 67][i % 9];
        hash = (hash * prime + sortedLabels[i]) % 1000000;
    }
    // Map the hash to an index in the available shades array
    var index = Math.abs(hash) % availableShades.length;
    return availableShades[index];
}
exports.getShadeForLabels = getShadeForLabels;
function formatSlotDuration(minutes) {
    var days = Math.floor(minutes / (24 * 60));
    minutes %= 24 * 60;
    var hours = Math.floor(minutes / 60);
    minutes %= 60;
    var result = [];
    if (days > 0) {
        result.push("".concat(days, " d"));
    }
    if (hours > 0) {
        result.push("".concat(hours, " h"));
    }
    if (minutes > 0 || (days === 0 && hours === 0)) {
        result.push("".concat(minutes, " min"));
    }
    return result.join(" ");
}
exports.formatSlotDuration = formatSlotDuration;
var eventBgColor = function (e, b, points, maxPoints) {
    if (e === types_1.UserPreferenceType.PERSONAL_BLOCKING) {
        return b ? "rgba(255, 217, 84, 0.5)" : "rgba(255, 217, 84, 1)";
    }
    if (e === types_1.UserPreferenceType.JUSTIFIED_BLOCKING) {
        return b ? "rgba(57, 208, 255, 0.5)" : "rgba(57, 208, 255, 1)";
    }
    if (Number(points) >= 0) {
        return b && points !== undefined && maxPoints
            ? "rgba(0, 157, 113, ".concat(Math.ceil((points / maxPoints) * 10) / 10, ")")
            : "rgba(0, 157, 113, 1)";
    }
    if (Number(points) < 0) {
        return b && points && maxPoints
            ? "rgba(255, 48, 48, ".concat(Math.ceil(-(points / maxPoints) * 10) / 10, ")")
            : "rgba(255, 48, 48, 1)";
    }
    return "#FFFF";
};
exports.eventBgColor = eventBgColor;
/**
 * Merges nested records from a data structure into a single flat record.
 *
 * @param data - A record where each value contains another record at the specified key
 * as well as many other records.
 * @param key - The key in each nested object containing the records to merge
 * @returns A single merged record combining all nested records at the specified key
 *
 * @example
 * const data = {
 *   1: { requests: { 100: {...}, 101: {...} } },
 *   2: { requests: { 102: {...}, 103: {...} } }
 * };
 * const merged = mergeRecords(data, 'requests');
 * // Result: { 100: {...}, 101: {...}, 102: {...}, 103: {...} }
 */
var mergeRecords = function (data, key) {
    var merged = {};
    for (var id in data) {
        // required to avoid type error guard-for-in
        if (Object.prototype.hasOwnProperty.call(data, id)) {
            merged = __assign(__assign({}, merged), data[id][key]);
        }
    }
    return merged;
};
exports.mergeRecords = mergeRecords;
var localeNormalizer = function (locale) {
    if (locale.includes("en"))
        return "en";
    else if (locale.includes("es"))
        return "es";
    // else if (locale.includes('fr')) return 'fr'
    else if (locale.includes("pt"))
        return "pt";
    else if (locale.includes("ca"))
        return "ca";
    else
        return "en";
};
exports.localeNormalizer = localeNormalizer;
// const mergeOtherUserRequests = (): Record<number, ExchangeRequest> => {
//   // Iterate over the 'itrs' object
//   let allOtherUserRequests: Record<number, ExchangeRequest> = {};
//   for (const id_itr in data) {
//     // required to avoid type error guard-for-in
//     if (Object.prototype.hasOwnProperty.call(data, id_itr)) {
//       allOtherUserRequests = {
//         ...allOtherUserRequests,
//         ...data[id_itr].other_users_pending_requests,
//       };
//     }
//   }
//   return allOtherUserRequests;
// };
var formatUserName = function (user, sliced) {
    return "".concat(user.firstname, " ").concat(sliced ? user.lastname.slice(0, 1) : user.lastname);
};
exports.formatUserName = formatUserName;
var minutesToHours = function (minutes) { return Math.floor(minutes / 60); };
exports.minutesToHours = minutesToHours;
/**
 * Merges multiple objects from iterations into a single object.
 *
 * @param iterations - The iterations object containing multiple objects to merge
 * @param keys - Array of keys to merge from each iteration
 * @returns Object containing merged data for each requested key
 *
 * @example
 * const iterations = {
 *   1: { sections: {...}, section_slots: {...} },
 *   2: { sections: {...}, section_slots: {...} }
 * };
 * const merged = mergeIterationData(iterations, ['sections', 'section_slots']);
 * // Returns: { sections: {...}, section_slots: {...} }
 */
function mergeIterationData(iterations, keys) {
    var result = {};
    // Initialize empty objects for each key
    keys.forEach(function (key) {
        result[key] = {};
    });
    var _loop_1 = function (id_itr) {
        if (Object.prototype.hasOwnProperty.call(iterations, id_itr)) {
            var iteration_1 = iterations[Number(id_itr)];
            keys.forEach(function (key) {
                Object.assign(result[key], iteration_1[key]);
            });
        }
    };
    // Merge data from each iteration
    for (var id_itr in iterations) {
        _loop_1(id_itr);
    }
    return result;
}
exports.mergeIterationData = mergeIterationData;
var checkPasswordRequirements = function (password, confirmPassword) {
    return {
        length: password.length >= 8,
        uppercase: /[A-Z]/.test(password),
        number: /\d/.test(password),
        noSpaces: !/\s/.test(password) && password.length > 0,
        passwordsMatch: password === confirmPassword && password.length > 0,
    };
};
exports.checkPasswordRequirements = checkPasswordRequirements;
var isUserSubscriptionActive = function (group) {
    return (!group.stripe_subscription_status ||
        group.stripe_subscription_status === types_1.StripeSubscriptionStatus.ACTIVE);
};
var isUserSubscriptionTrial = function (group) {
    return group.stripe_subscription_status === types_1.StripeSubscriptionStatus.TRIALING;
};
var calculateGracePeriodDaysLeft = function (stripe_period_end) {
    var endDate = new Date(stripe_period_end);
    var today = new Date();
    return Math.ceil((today.getTime() - endDate.getTime()) / (1000 * 60 * 60 * 24));
};
var calculateFreeTrialDaysLeft = function (stripe_period_end) {
    var endDate = new Date(stripe_period_end);
    var today = new Date();
    return Math.ceil((endDate.getTime() - today.getTime()) / (1000 * 60 * 60 * 24));
};
var SubscriptionStatusBanner;
(function (SubscriptionStatusBanner) {
    SubscriptionStatusBanner["ACTIVE"] = "active";
    SubscriptionStatusBanner["GRACE_PERIOD"] = "grace_period";
    SubscriptionStatusBanner["TRIAL_ENDING"] = "trial_ending";
    SubscriptionStatusBanner["EXPIRED"] = "expired";
})(SubscriptionStatusBanner || (exports.SubscriptionStatusBanner = SubscriptionStatusBanner = {}));
exports.expiredSubscriptionStatuses = [
    types_1.StripeSubscriptionStatus.PAST_DUE,
    types_1.StripeSubscriptionStatus.INCOMPLETE,
    types_1.StripeSubscriptionStatus.INCOMPLETE_EXPIRED,
    types_1.StripeSubscriptionStatus.UNPAID,
    types_1.StripeSubscriptionStatus.CANCELED,
    types_1.StripeSubscriptionStatus.PAUSED,
];
var userSubscriptionStatus = function (group) {
    if (isUserSubscriptionActive(group))
        return { status: SubscriptionStatusBanner.ACTIVE, daysLeft: undefined };
    if (isUserSubscriptionTrial(group))
        return {
            status: SubscriptionStatusBanner.TRIAL_ENDING,
            daysLeft: calculateFreeTrialDaysLeft(group.stripe_period_end),
        };
    if (exports.expiredSubscriptionStatuses.includes(group.stripe_subscription_status)) {
        var gracePeriodDaysLeft = calculateGracePeriodDaysLeft(group.stripe_period_end);
        if (gracePeriodDaysLeft <= 10) {
            return {
                status: SubscriptionStatusBanner.GRACE_PERIOD,
                daysLeft: gracePeriodDaysLeft,
            };
        }
        return { status: SubscriptionStatusBanner.EXPIRED, daysLeft: undefined };
    }
    return { status: SubscriptionStatusBanner.ACTIVE, daysLeft: undefined };
};
exports.userSubscriptionStatus = userSubscriptionStatus;
var isAllowedToUsePlatform = function (banner) {
    return banner !== SubscriptionStatusBanner.EXPIRED;
};
exports.isAllowedToUsePlatform = isAllowedToUsePlatform;
var getSubscriptionStatusColor = function (status) {
    switch (status) {
        case types_1.StripeSubscriptionStatus.ACTIVE:
            return "bg-green-100 text-green-700";
        case types_1.StripeSubscriptionStatus.INCOMPLETE:
            return "bg-red-100 text-red-700";
        case types_1.StripeSubscriptionStatus.TRIALING:
            return "bg-yellow-100 text-yellow-700";
        case types_1.StripeSubscriptionStatus.PAST_DUE:
            return "bg-red-100 text-red-700";
        case types_1.StripeSubscriptionStatus.CANCELED:
            return "bg-gray-100 text-gray-700";
        case types_1.StripeSubscriptionStatus.UNPAID:
            return "bg-gray-100 text-gray-700";
        case types_1.StripeSubscriptionStatus.INCOMPLETE_EXPIRED:
            return "bg-gray-100 text-gray-700";
        case types_1.StripeSubscriptionStatus.PAUSED:
            return "bg-amber-100 text-amber-700";
        default:
            return "bg-gray-100 text-gray-700";
    }
};
exports.getSubscriptionStatusColor = getSubscriptionStatusColor;
function getUserRuleParticipation(allUserRequirements, userId) {
    var result = {};
    // Check each rule to see if the user participates
    Object.entries(allUserRequirements).forEach(function (_a) {
        var ruleId = _a[0], rule = _a[1];
        var userRequirements = rule.user_reqs || {};
        result[Number(ruleId)] = !!userRequirements[userId];
    });
    return result;
}
exports.getUserRuleParticipation = getUserRuleParticipation;
function getRandomIcon() {
    return constants_1.LabelIcons[Math.floor(Math.random() * constants_1.LabelIcons.length)];
}
exports.getRandomIcon = getRandomIcon;
function getRandomColor() {
    return constants_1.colorNames[Math.floor(Math.random() * constants_1.colorNames.length)];
}
exports.getRandomColor = getRandomColor;
